//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class CoreWebAccountStimulusControllers
{
	public static accountLoginLinkLoginLinkSent: string = `account-login-link--login-link-sent`;
	public static accountLoginLinkLogin: string = `account-login-link--login`;
}
